const displayName = 'Kayenta Stories'
const appName     = 'kayenta_stories'

export { displayName, appName }
